import React from "react";
import { CourseItemDashBoard, isTrue } from "../../../../../service/service";
import style from "./DateItem.module.scss";
import { Badge, Button, Icon, message } from "antd";
import Config from "../../../../../config";
import { stopJump } from "../../../../../utils/common";

interface DateItemProps {
    data: CourseItemDashBoard;
}

export default function DateItem({ data }: DateItemProps) {
    function onClickCourse() {
        if (data.platformType === "1")
            window.open(
                `${Config.PreviewUrl}?versionCode=${data.lmsCourseNo}&customerId=120`
            );
        else onClickPlatform();
    }

    function onClickLive() {
        return stopJump(data.liveUrl, null);
    }

    function onClickPlatform() {
        if (data.courseUrl) window.open(data.courseUrl);
        else message.warn("没有该平台的访问地址");
    }

    function hasLive() {
        return /channelId=\d+/.test(data.liveUrl);
    }

    return (
        <div className={style.root}>
            <div className={style.course} onClick={onClickCourse}>
                <Badge status="warning" className={style.Badge} /> {data.name}
            </div>

            <div className={style.teacher}>{data.teacher}</div>

            <div className={style.tools}>
                {isTrue(data.isLive) &&
                    hasLive() &&
                    data.platformType === "1" && (
                        <Button
                            type="primary"
                            size="small"
                            className={style.button1}
                            onClick={onClickLive}>
                            <Icon type="clock-circle" theme="filled" /> 直播
                        </Button>
                    )}
                {!isTrue(data.isLive) && data.platformType === "1" && (
                    <Button
                        type="primary"
                        size="small"
                        className={style.button2}
                        onClick={onClickCourse}>
                        <Icon type="video-camera" /> 录播
                    </Button>
                )}
                {data.platformType !== "1" && (
                    <p className={style.platform} onClick={onClickPlatform}>
                        <PlatformLogo platformType={data.platformType} />
                    </p>
                )}
            </div>
        </div>
    );
}

function PlatformLogo({ platformType }: { platformType: string }) {
    if (platformType === "雨课堂")
        return <img src={require("./img/ykt.png")} alt="" />;
    if (platformType === "超星学习通")
        return <img src={require("./img/cx.png")} alt="" />;
    if (platformType.substr(0, 4) === "中国大学")
        return <img src={require("./img/mooc.png")} alt="" />;
    return <span>{platformType}</span>;
}
